import api from "../utils/API";

// Base URL for your API
export const distributorService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/distributer", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createDistributor: async (payload) => {
    try {
      const response = await api.post("/admin/distributer", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateDistributor: async (id, payload) => {
    try {
      const response = await api.put(`/admin/distributer/${id}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteDistributor: async (id) => {
    try {
      const response = await api.delete(`/admin/distributer/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDistributorById: async (id) => {
    try {
      const response = await api.get(`/admin/distributer/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDistributorOptions: async () => {
    try {
      const response = await api.get(`/admin/distributer/all`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
